'use client';

import { researchGroupListingSection } from '@stereoagency/sanity-schema';
import { useContext } from 'react';
import useSWR from 'swr';
import { researchGroupQuery } from './researchGroupQuery';
import ResearchGroupListingSection from './ResearchGroupListingSection.client';
import { SanityDraftClientContext } from '@/components/context';

type Props = Omit<
  typeof researchGroupListingSection.schema.researchGroupListingSection,
  '_type'
> & {};

export default function DraftModeResearchGroupListingSection({
  enableTaxonomyFilter,
  staticFilter
}: Props) {
  const { client } = useContext(SanityDraftClientContext);
  const { data } = useSWR('researchGroups', () =>
    client?.fetch<(typeof researchGroupQuery)[1]>(
      researchGroupQuery[0],
      { taxonomies: staticFilter?.map((tax) => tax._ref) ?? [] }
    )
  );

  return (
    <ResearchGroupListingSection
      enableTaxonomyFilter={enableTaxonomyFilter}
      groups={data ?? []}
    />
  );
}
